import { RouteRecordRaw } from 'vue-router';

export const signLanguageRoute: RouteRecordRaw = {
  name: 'SignLanguageView',
  path: '/sign-language',
  component: () => import('@/modules/SignLanguage/SignLanguage.vue'),
};
